module.exports = __webpack_public_path__ + "img/boy.b22b2812.png";